import React from 'react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import MetricChartWidget from 'components/widgets/charts/MetricChartWidget';
import { TimeSeriesPoint } from 'components/widgets/charts/TimeSeriesChart';
import { useGrowthMetrics } from './useAdminStatus';

interface GrowthSectionProps {
    viewerToken?: string;
}

// Renders the cumulative growth chart of environments and users
const GrowthSection: React.FC<GrowthSectionProps> = ({ viewerToken }) => {
    const { t } = useTranslation();
    const { points, loading } = useGrowthMetrics(viewerToken);

    // Map the growth points onto chart points
    const chartPoints: TimeSeriesPoint[] = points.map(point => ({
        timestamp: point.timestamp,
        environments: point.environments,
        users: point.users,
    }));

    return (
        <div className='admin-growth-section'>
            <MetricChartWidget
                title={t('dashboard.monitoring.admin.growth.title')}
                subtitle={t('dashboard.monitoring.admin.growth.subtitle')}
                data={chartPoints}
                series={[
                    { key: 'environments', label: t('dashboard.monitoring.admin.growth.environments_series'), color: 'var(--primary-color)' },
                    { key: 'users', label: t('dashboard.monitoring.admin.growth.users_series'), color: 'var(--general-blue)' },
                ]}
                loading={loading}
                xFormatter={(value: string) => dayjs(value).format('DD-MM')}
                allowDecimals={false}
            />
        </div>
    );
};

export default GrowthSection;
